import CommandManager from "../../../../vendor_core/core/src/commands/CommandManager";
import BetModel from "../../../../vendor_core/core/src/model/BetModel";
import BuyFeatureModel from "../../../../vendor_core/core/src/model/BuyFeatureModel";
import { UIButtons } from "../../../../vendor_core/core/src/ui/UIButtons";
import UIController from "../../../../vendor_core/core/src/ui/UIController";
import { DefaultLayers } from "../../../../vendor_core/core/src/utils/Layers";
import Locale from "../../../../vendor_core/core/src/utils/Locale";
import ViewManager from "../../../../vendor_core/core/src/utils/ViewManager";
import SwitchButton from "../../../../vendor_core/core/src/views/components/SwitchButton";
import TextField from "../../../../vendor_core/core/src/views/components/TextField";
import { VendorCommandsEnum } from "../../../../vendor_core/src/commands/VendorCommandsEnum";
import * as GameCommands from "../../../../vendor_core/core/src/commands/GameCommands";
import KeyboardManager from "../../../../vendor_core/core/src/utils/KeyboardManager";
import ConfigManager from "../../../../vendor_core/core/src/managers/ConfigManager";
import { ConfigurationTypes } from "../../../../vendor_core/core/src/const/ConfigurationTypes";
import Configs from "../../../../vendor_core/src/vendorConfigs/Configs";
import Button from "../../../../vendor_core/core/src/views/components/Button";
import GameModel from '../../../../vendor_core/core/src/model/GameModel';
import Layout from '../../../../vendor_core/core/src/utils/Layout';


export function ShowBuyFeatureOptions(callback) {
    const betBarButtons = ViewManager.getLayer(DefaultLayers.BetBar).setScene().buttons;
    const featSpinButton = betBarButtons.get("buyfeatureSpin") as SwitchButton;

    if (featSpinButton.isSelected()) {
        BuyFeatureModel.isActivated = false;
        BuyFeatureModel.mode = 0;
        BuyFeatureModel.extraParams = [];
        BuyFeatureModel.hasBuyFeatureIsTriggered = false;
        CommandManager.execute(VendorCommandsEnum.BALANCE_UPDATE, BetModel.balance);
        GameCommands.UpdateBalanceCommand();
        KeyboardManager.enable();
        (betBarButtons.get(UIButtons.Spin) as SwitchButton).switch(false);
        (betBarButtons.get(UIButtons.Stop) as SwitchButton).switch(false);
        (betBarButtons.get(UIButtons.StopAutoplay) as SwitchButton).switch(false);
        (betBarButtons.get(UIButtons.Bet) as SwitchButton).switch(false);
        betBarButtons.get(UIButtons.Bet).setEnabled(true);
        ViewManager.getLayer(DefaultLayers.BetBar).setScene()
            .sceneMoneyFields.get("betBuySpin").visible = false;
        featSpinButton.switch(!featSpinButton.isSelected());
    } else {
        UIController.toggleComponent("buyFeatureSpin", callback);
    }

}

export function ToggleAutoplayPopupCommand(visible) {
    const isBuyFeatureEnabled = ConfigManager.hasConfig(ConfigurationTypes.GAME) && !Configs.game.clientConfig.disableBuyFeature;
    const isTurboEnable = ConfigManager.hasConfig(ConfigurationTypes.GAME) && Configs.game.clientConfig.quickStop;
    const disabledBtnNames: string[] = [UIButtons.AutoPlay, UIButtons.Spin, UIButtons.Bet, UIButtons.Settings];

    const buttons = ViewManager.getLayer(DefaultLayers.BetBar)
        .setScene().buttons;

    if ( isTurboEnable && buttons.has("turbo")) {
        disabledBtnNames.push(UIButtons.Turbo);
    }

    if (isBuyFeatureEnabled) {
        let buyBtnsGroup = ViewManager.getLayer(DefaultLayers.BetBar)
            .setScene().groups.get("btn_buy_feature");
        // check for all buy buttons in their group and add them to the disabledBtnNames
        buyBtnsGroup.children.forEach((child) => {
            if (child instanceof Button) {
                buttons.forEach((btn, name) => {
                    if (child == btn) {
                        disabledBtnNames.push(name);
                    }
                });
            }
        });
    }

    buttons.forEach((btn, name) => {
        if(disabledBtnNames.indexOf(name) != -1) {
            if ((name == UIButtons.Bet || name == UIButtons.FeatureBuy ) && BuyFeatureModel.isActivated) {
                btn.setEnabled(false);
            } else {
                btn.setEnabled(visible != true ? false : true);
            }
        }
    });
    GameCommands.ToggleAutoplayPopupCommand();

}
